var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAlert',{staticClass:"tw-block",attrs:{"title":"Cancelled","theme":"neutral"}},[_vm._v(" "+_vm._s(_vm.event.asNotice(_vm.activeEmployment))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }